export default "__VITE_ASSET__CXUK$uys__"